<template>

    <div>
        <b-form-group id="igEmail">
            <b-form-input id="email"
                          name="email"
                          placeholder="Email *"
                          v-model="dataInput"
                          :state.sync="validInput"
                          v-on:input="inputTextChange"
                          aria-describedby="emailFeedback"></b-form-input>
            <b-form-invalid-feedback id="emailFeedback">Musíte vyplnit validní email.</b-form-invalid-feedback>
        </b-form-group>
    </div>

</template>

<script>

    export default {
        name: 'emailFormInput',
        data: function () {
            return {
                localModel: this.model,
                localValid: this.valid
            }
        },
        props: {
            model: {
            },
            valid: {
            }
        },
        computed: {
            dataInput: {
                get: function () {
                    return this.model;
                },
                set: function (newValue) {
                    this.localModel = newValue
                }
            },
            validInput: {
                get: function () {
                    return this.valid;
                },
                set: function (newValue) {
                    this.localValid = newValue
                }
            }
        },
        mounted() {
        },
        methods: {
            inputTextChange() {
                this.$emit('update:model', this.localModel);
            }
        }
    }

</script>